import React from 'react';
import ReactPlayer from 'react-player/lazy';
import { generateCss, generateEvent, generateSrc, generateStyle } from '../../functions/sortableFunctions';

const Video = ({ block, ...props }: any) => {

    return (
        <React.Fragment>
            {
                React.createElement(
                    ReactPlayer,
                    {
                        url: generateSrc({
                            props: {
                                ...props,
                                block: block
                            },
                            key: "url"
                        }),
                        light: generateSrc({
                            props: {
                                ...props,
                                block: block
                            },
                            key: "light"
                        }),
                        controls: block.data.controls ?? true,
                        width: block.data.width ?? "100%",
                        height: block.data.height ?? "100%",
                        volume: block.data.volume ?? null,
                        muted: block.data.muted ?? false,
                        loop: block.data.loop ?? false,
                        style: generateStyle({
                            props: {
                                ...props,
                                block
                            }
                        }),
                        className: generateCss({
                            props: {
                                ...props,
                                block: block
                            }
                        }),
                        playing: block.data.playing ?? false,
                        onClick: block.events?.onClick ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onClick"
                            });
                        } : null,
                        onDoubleClick: block.events?.onDoubleClick ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onDoubleClick"
                            });
                        } : null,
                        onContextMenu: block.events?.onContextMenu ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onContextMenu"
                            });
                        } : null,
                        onMouseOver: block.events?.onMouseOver ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onMouseOver"
                            });
                        } : null,
                        onMouseLeave: block.events?.onMouseLeave ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onMouseLeave"
                            });
                        } : null
                    },
                    null
                )
            }
        </React.Fragment>
    )
}
export default Video; 